<template>
	<div class="container-fluid" v-if="!loading">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mm-0 " @click="getOrganizationDetail">Program progress detail </h4>
						<h5>HHA: {{ provider.full_name }}</h5>
						<h5>Agency: {{ organization.name }}</h5>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
		</div><!--row-->

		<div class="row">
			<div class="col-6">
				<div class="h5 border-bottom pb-2 text-uppercase green">Program</div>
			    <div class="lightgray-content p-4 mb-2">
			        <div class="white-content p-3">
			            <p class="border-bottom pt-2 pb-2 mb-0 d-flex align-items-center "><strong>Name</strong>: <span class="h2 green m-0 italic ml-2">{{ course.name }}</span></p>
			            <p class="border-bottom pt-2 pb-2 mb-0"><strong>Description</strong>: {{ course.description }}</p>
			            <p class="border-bottom pt-2 pb-2 mb-0 d-flex justify-content-start align-items-center w-100">
			                <strong>Total lessons</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ course.total_lessons }}</span> /
			                <strong>Completed</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ course.total_lessons_completed }}</span>
			            </p>
			            <p class="border-bottom pt-2 pb-2 mb-0 d-flex justify-content-start align-items-center w-100">
			                <strong>Completed at</strong>: <span class="h3 m-0 ml-2 mr-2 regular">{{ course.provider_completion_date ? course.provider_completion_date : '-' }}</span>
			            </p>
			            <div class="border-bottom pt-2 pb-2 mb-0 d-sm-flex justify-content-between align-items-center">
			                <strong class="mr-2">Progress: </strong>
			                <div class="completion-bar">
			                    <div v-bind:style="{ width: course.completion + '%' }"></div>
			                    <span>{{ Math.trunc(course.completion) }}%</span>
			                </div>
			            </div>
			        </div>
			       </div>
			</div>

			<div class="col-6">
				<div class="lightgray-content p-2 mb-2 mt-5">
					<div class="program-detail">
		        		<!-- <div class="h5 ">Modules</div> -->

			            <div no-body class="border-bottom mb-1" v-for="(module, i) in modules">
			                <div v-b-toggle="'accordion'+(i + 1)" variant="info" class="variant cursor-pointer h6 pt-3 pb-3 m-0 regular">
			                    <div class="row">
			                        <div class="col-12 col-xl-6">

			                            <strong>{{ module.title }} ({{ module.completed_lessons }}/{{ module.total_lessons }})</strong>
			                        </div>
			                        <div class="col-11 col-xl-4">
			                            <div class="completion-bar completion-bar-xs">
			                                <div v-bind:style="{ width:  module.completion + '%' }"></div>
			                                <span>{{ Math.trunc(module.completion) }}%</span>
			                            </div>
			                        </div>
			                    </div>
			                </div>
			                <b-collapse :id="'accordion'+(i+1)" visible accordion="my-accordion" role="tabpanel">
			                    <div>
			                        <div class="white-content p-3 mb-3">
			                            <div>
			                                <ul class="lessons list-unstyled">
			                                    <li v-for="(lesson, j) in module.lessons">
			                                        <div v-bind:class="{ completed : lesson.completed }" class="pt-1 border-bottom pb-1 d-flex justify-content-between align-items-center ">
			                                            <div class="mb-2">
			                                                <a class="green" @click="showLessonDetail(lesson.id)"><strong>{{ j+1 }}</strong>. {{ lesson.title }} </a>
			                                                <br />
			                                                <span v-if="lesson.completed"><small>(Completed at: {{ lesson.completed_at }})</small></span>
			                                            </div>

				                						<div class="actions d-flex justify-content-end">

				                							<span v-b-tooltip.hover title="Mark as completed"  class="button m-0" v-if="!lesson.completed" @click="markAsCompleted(lesson.id)">	<img src="../../../assets/images/icons/solid/check_white.svg" width="9"  />
				                							</span>
				                							
				                							<!--
				                							<span v-b-tooltip.hover title="Mark as completed"  class="button m-0" v-if="!lesson.completed" @click="markAsCompleted(lesson.id)">	<img src="../../../assets/images/icons/solid/check_white.svg" width="9"  />
				                							</span>

				                							<span  v-b-tooltip.hover title="View lesson details" class="button m-0 ml-1 text-center" @click="showLessonDetail(lesson.id)">
				                								<img src="../../../assets/images/icons/solid/info_white.svg" width="5"  />
				                							</span>
															-->
				                						</div>
			                                        </div>
			                                    </li>
			                                </ul>
			                            </div>
			                        </div>
			                    </div>
			                </b-collapse>
			            </div>
			        </div>
			    </div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data : function(){
			return {
				provider_id : this.$route.params.id,
				organization_id : this.$route.params.organization_id,
				course_id : this.$route.params.course_id,
				loading : false,
				course : null,
				modules : null,
				provider : null,
				organization : null
			}
		},

		created : function(){
			this.getOrganizationDetail();
		},

		methods : {
			getOrganizationDetail : function(){

				var params = {
					id : this.provider_id,
					organization_id : this.organization_id,
					course_id : this.course_id
				}

				this.loading = true;

				this.$store.dispatch('getProviderOrganizationCourse', params).then((res) => {

					this.provider = res.data.data.provider;
					this.course = res.data.data.course;
					this.modules = res.data.data.modules;
					this.organization = res.data.data.organization;


					this.loading = false;
					console.log(res);
				}).catch((error) => {
					console.log(error);
				});
			},

			showLessonDetail : function(lesson_id){

			},

			markAsCompleted : function(lesson_id){
				var params = {
					id : this.course_id, 
					provider_id : this.provider_id,
					lesson_id : lesson_id,
					filters : {
						organization_id : this.organization_id
					}
				}

				this.$store.dispatch('markCourseProviderLessonCompleted', params).then((res) => {
					for(var i in this.modules){
						 for(var j in this.modules[i].lessons){
						 	if(this.modules[i].lessons[j].id == lesson_id){
						 		this.modules[i].lessons[j].completed = true;
						 	}
						 }
					}
					this.getOrganizationDetail();
				}).catch((error) => {
					console.log(error);
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/admin/providers/AdminProviderOrganizationCourseDetail.vue